module.exports = __webpack_public_path__ + "static/media/category2.14d451b5.png";